const assetManager = {
  key: "asset-manager",
  title: "Asset Manager",
  angle: -60,
  summary: "Control assets standards from a single hub.",
  releaseDate: "End 2026",
  launch: "/",
  planStages: [
    {
      name: "Scoping documents",
      detail: [
        {
          text: "Concept feature",
          checked: true,
        },
        {
          text: "Business Systems Requirements Document (BSRD)",
          checked: true,
        },
        {
          text: "Functional Design Document (FDD)",
          checked: false,
        },
      ],
      completionDate: "Aug 26",
    },
    {
      name: "Development",
      detail: [
        {
          text: "Admin feature development & testing",
          checked: false,
        },
        {
          text: "Main feature development",
          checked: false,
        },
        {
          text: "Asset data entry",
          checked: false,
        },
        {
          text: "Development phase testing",
          checked: false,
        },
      ],
      completionDate: "Oct 26",
    },
    {
      name: "Testing & QA",
      detail: [
        {
          text: "Workflow documents production",
          checked: false,
        },
        {
          text: "Main feature testing",
          checked: false,
        },
        {
          text: "Training & support documentation production",
          checked: false,
        },
        {
          text: "Training and deployment",
          checked: false,
        },
      ],
      completionDate: "Dec 26",
    },
  ],
  points: [
    "Create standard asset templates",
    "Link assets to data and models for a single source of truth",
    "Govern asset property updates",
    "Add assets to projects and manage their lifecycle",
  ],
};

export default assetManager;
